import React from 'react';
import { Spreadsheet } from '../image_index';

export const sections = [
    {
        id: 'cct_empathize',
        title: 'Empathizing',
        content: (
            <div>
                <p>
                    Modern premium credit cards offer hundreds of dollars in statement credits, travel perks, and dining allowances.
                    However, managing multiple cards often leads to missed benefit deadlines, forgotten fee renewal dates, and underutilized rewards.
                </p>
                <img src={Spreadsheet} alt='example google sheets' />
                <p>
                    <b>The target audience includes:</b>
                    <ul>
                        <li>Financial enthusiasts</li>
                        <li>Travel-hackers</li>
                        <li>Everyday cardholders who manage 3+ rewards cards</li>
                        <li>Anyone who needs a centralized dashboard to track recurring fees and perk statuses</li>
                    </ul>
                </p>
            </div>
        )
    },
    {
        id: 'cct_define',
        title: 'Problem Statement',
        content: (
            <div>
                <p>
                    <i>How do we provide cardholders with a quick, high-level snapshot of their portfolio so they can monitor annual fees, track benefit status, and prevent unexpected charges without manual spreadsheet management?</i>
                </p>
                <p><b>Core Objectives</b></p>
                <ul>
                    <li><b>Scannability:</b> Present key details (Annual Fee, Fee Date, Tracked Benefits, Status) at a single glance.</li>
                    <li><b>Efficient Data Management:</b> Provide intuitive search, sorting, and filtering capabilities to manage larger card collections.</li>
                    <li><b>Clear Visual Hierarchy:</b> Distinguish card status (e.g., Active) and interactive triggers with consistent typography and color badges.</li>
                    <li><b>Automated Reminder Scheduling:</b> Eliminates manual tracking by sending proactive alerts before annual fee posting dates and benefit expiration windows.</li>
                </ul>
            </div>
        )
    },
    {
        id: 'cct_ideate',
        title: 'Design',
        content: (
            <div>
                WIP
                <div class='figma_embed_container'>
                    <iframe title='credit_card_tracker' src="https://embed.figma.com/proto/nk6cGa8Gitro9rswim9UX3/Credit-Card-Tracker?node-id=2-2&p=f&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=2%3A2&scaling=contain&show-proto-sidebar=1&embed-host=share" allowfullscreen></iframe>
                </div>
            </div>
        )
    },
];